import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "../ui/button";

interface IResultsPopoverProps {
  responseJSON: string;
  handleExportCSV: () => void;
  handleExportJSON: () => void;
  disabled?: boolean;
}

export default function ResultsPopover({
  responseJSON,
  handleExportCSV,
  handleExportJSON,
  disabled = false,
}: IResultsPopoverProps) {
  const isDisabled = disabled || !responseJSON;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          className="!p-0 text-lg font-medium text-white"
          icon
          disabled={isDisabled}
        >
          <i className="ri-save-line text-md text-white"></i>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="end"
        sideOffset={0}
        className="border-dark-border w-auto !p-1.5"
      >
        <div className="flex flex-col items-start">
          <Button
            variant="ghost"
            className="hover:bg-accent hover:bg-dark-elevated w-full justify-start !p-1.5 text-xs text-white"
            onClick={handleExportCSV}
            disabled={isDisabled}
          >
            Save as CSV
          </Button>
          <Button
            variant="ghost"
            className="hover:bg-accent hover:bg-dark-elevated w-full justify-start !p-1.5 text-xs text-white"
            onClick={handleExportJSON}
            disabled={isDisabled}
          >
            Save as JSON
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
